export enum SimTypeEnum {
  physical = 0,
  eSim = 1,
}
